import { ApplicationInitStatus, Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import { cloneDeep } from 'lodash';
import { CartItem } from 'src/app/modals/cart-item';
import { UserServiceModal } from 'src/app/modals/userservice.modal';
import { CartService } from './cart.service';
import { NotificationService } from './notification.service';
import { ProductService } from './product.service';
import { RestApiService } from './restapi.service';
import { UserService } from './user.service';
import { ConfigService } from './config.service';
import { UtilityService } from './utility.service';
import { CompanyService } from './company.service';
import { ShoppingCartService } from './shopping-cart.service';
import { ShippingMethodService } from './shipping-method.service';
import { BounceBackService } from './bounceback.service';
import { BounceBackUtilsService } from './bounceback-utils.service';
import { Router } from '@angular/router';
import { AUTOSHIPSTOREID, CORPORATESTOREID, DefaultCountry, DefaultShipMethodID, FreeEnrollmentItemID, FreeEnrollmentZeroPriceItemID, IBOSTOREID, RETAILSTOREID, MEMBERSTORE, ENROLLMENTSTORE, MAINSTORE, updateStoreConstants, StoreData } from 'src/app/constant';
import { StoreConstantsService } from './store-constants.service';
@Injectable({
  providedIn: 'root'
})
export class OrderService {
  public calculateOrderResponse: any = {};
  public  calculateAutoOrderResponse: any = {};
  public lastRequest = {};
  public lastAutoOrderRequest = {};
  shoppingCartItems: CartItem[] = [];
  public packTotal = 0;
  public packBusinessVolume = 0;
  public orderTotal = 0;
  public orderRewardTotal = 0;
  public orderBusinessVolume = 0;
  public autoorderBusinessVolume = 0;
  public PreventTaxJarCalculation: boolean = true;
  public UsePoints: boolean = false;
  public calculateOrderCall: boolean;
  public userService: UserServiceModal;
  autoshipStoreId: any;
  retailStoreId: any;
  enrollStoreId: any;
  constructor(
    public user: UserService,
    public notificationService: NotificationService,
    private router: Router,
    public route: ActivatedRoute,
    public cartService: CartService,
    public apiService: RestApiService,
    public translate: TranslateService,
    public itemsService: ProductService,
    public configService: ConfigService,
    public appInit: ApplicationInitStatus,
    public utilityService: UtilityService,
    public companyService: CompanyService,
    public shoppingCartService: ShoppingCartService,
    public shippingMethodService: ShippingMethodService,
    public bounceBackService: BounceBackService,
    public bounceBackUtils: BounceBackUtilsService,
    private storeConstantsService: StoreConstantsService,
  ) {
    // Grab the userServiceModal reference immediately so dependent services
    // (e.g. Cart1Service) that call calculateOrder() during their own
    // construction don't hit `this.userService` as undefined before the
    // first NavigationEnd fires.
    this.userService = this.user.userServiceModal;

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        let currentRoute = this.route;
        while (currentRoute.firstChild) {
          currentRoute = currentRoute.firstChild;
        }

        this.userService = this.user.userServiceModal;
        appInit.donePromise.then(() => this.onInit());
        this.getstoreId();
      }
    });
  }

  onInit(): void {
    this.cartService.getItems().subscribe(shoppingCartItems => this.shoppingCartItems = shoppingCartItems);
    if((this.itemsService.selectedOrderItems || this.itemsService.selectedPacks) && this.itemsService.selectedOrderItems.length>0){
      this.calculateOrder();
    }
    if(this.itemsService.selectedAutoOrderItems && this.itemsService.selectedAutoOrderItems.length>0){
      this.calculateAutoOrder();
    }
  }
  /**
   * Returns true when the current route is part of the enrollment funnel
   * (or the cart contains an enrollment-pack SKU). Used to force
   * StoreId = ENROLLMENTSTORE on CalculateOrder, overriding any stale
   * `selectedStoreId` left in sessionStorage by /shop / market-selector /
   * "Shop Now" navigation. See Griff T-0129 plan.
   */
  private isEnrollmentContext(): boolean {
    try {
      const url = (this.router?.url || '').toLowerCase();
      if (/(^|\/)(application|join|complete)(\/|$|\?)/.test(url)) return true;
      // FLP-* (enrollment pack) lives in selectedPacks under normal /join
      // flow, but a few code paths leave it in selectedOrderItems. Check
      // both buckets so the override fires regardless of where the pack
      // lands. Closes 2026-05-15 Cluster B (anon TF7-FLP-701 on /www
      // routing to MAINSTORE).
      const hasFLP = (arr: any[]) => (arr || []).some((it: any) =>
        /(^|-)FLP-\d+$/i.test(it?.ItemID || it?.itemId || ''));
      if (hasFLP(this.itemsService?.selectedPacks)) return true;
      if (hasFLP(this.itemsService?.selectedOrderItems)) return true;
    } catch (_) { /* defensive */ }
    return false;
  }

  /*** calculate Order ***/
  public calculateOrder(showNotification?: boolean): any {
    const promise = new Promise((resolve, reject) => {
      let orderSubtotal = 0;
      const productdetails = [];
      const kititems = [];

      this.itemsService.selectedOrderItems.forEach((item, index) => {
        orderSubtotal += (item.Price || 0) * (item.Quantity || 1);
        productdetails.push({
          ItemId: item.ItemID,
          Quantity: item.Quantity || 1,
          // IsReward: false, // item.UsePoints
        });
      });


      this.itemsService.selectedPacks.forEach((item, index) => {
        orderSubtotal += (item.Price || 0) * (item.Quantity || 1);
        productdetails.push({
          ItemId: item.ItemID,
          Quantity: item.Quantity || 1,
          // IsReward: false
        });
      });

      if (this.userService?.couponInfo?.promoCode) {
        const isInCart = this.userService.couponInfo.Allcoupons.some((code) =>  {
          if (code == this.userService.couponInfo.promoCode) {
            return true;
          }
          return false;
        });
        if (!isInCart) {
          this.userService.couponInfo.Allcoupons.push(this.userService.couponInfo.promoCode);
        }
      }
      const token = null; // cookieService.getAuthToken();
      const guestLogin = localStorage.getItem('guestLogin') == 'true' ? true : false;
      if (token && !guestLogin) {
        const selectedorders = JSON.parse(localStorage.getItem('cart.order'));
        if (!selectedorders || !selectedorders.length) {
          this.userService.couponInfo.RewardsForUse = [];
          this.userService.couponInfo.promoCode = '';
          this.userService.couponInfo.promoCodeValid = true;
          this.userService.couponInfo.IsAppliedcode = false;
          this.userService.couponInfo.Allcoupons = [];
        }
      }
      this.CustomerTypeChanged();
      const selectedCountry = this.configService.commonData.selectedCountry || DefaultCountry;
      const addressData = this.configService.commonData?.CountryCode?.[selectedCountry]; 
      
      // Set the first shipping method ID by default
      let shipMethodId = this.userService?.selectedShippingMethod;
      
      // If no shipping method is selected, use the shipping method service to get the default
      if (!shipMethodId) {
        shipMethodId = this.shippingMethodService.getShippingMethodId(orderSubtotal, this.userService.customerTypeID, false);
      }
      
      // If still no shipping method, use the default from constants
      if (!shipMethodId) {
        shipMethodId = DefaultShipMethodID;
      }
      const calculateOrderRequest = {
        customerType: this.userService.customerTypeID || this.userService.customerData?.CustomerType || 2,
        // customerType: (sessionStorage.getItem('IsEnrollment') != 'true' && this.itemsService.selectedAutoOrderItems?.length > 0) ? 3 : this.userService.enrollerInfo?.CustomerType ||1,
        customerId: this.isLoggedIn() ? (this.userService.customerData?.CustomerId ? this.userService.customerData?.CustomerId: this.userService.enrollerInfo?.CustomerId) : "",
        OrderId:"",
        calculateOrder: {
          // WarehouseId: 0,
          ShipMethodId: shipMethodId,
          StoreId: this.isEnrollmentContext()
            ? this.storeConstantsService.getCurrentStoreConstants().ENROLLMENTSTORE
            : (sessionStorage.getItem('selectedStoreId') || ((!this.isLoggedIn() && this.userService.customerTypeID == 1) ? this.storeConstantsService.getCurrentStoreConstants().IBOSTOREID : this.user?.userServiceModal?.customerData?.IsCorporate == true ?  this.storeConstantsService.getCurrentStoreConstants().CORPORATESTOREID : this.storeConstantsService.getCurrentStoreConstants().RETAILSTOREID)),
          CurrencyCode: this.companyService.selectedCurrency.CurrencyCode,
          // ShippingAddress: {
          //   AddressId: 0,
          //   Street1: 'testaddress',//this.userService.shippingAddress?.Street1 || addressData?.Line1,
          //   Street2: this.userService.shippingAddress?.Street2 || addressData?.Line2,
          //   Street3: ' ',
          //   StateCode: "UT",
          //   PostalCode: "84043",//this.userService.shippingAddress?.PostalCode || this.userService.shippingAddress?.PostalCode || addressData?.Zip,
          //   City: "TestCity",//this.userService.shippingAddress?.City || addressData?.City,
          //   Region: "UT",//this.userService.shippingAddress?.Region ? this.userService.shippingAddress.Region : (this.userService.defaultState || this.userService.regionMainState) || addressData?.StateCode,
          //   CountryCode: this.userService?.selectedCountry ||this.configService.commonData.selectedCountry || selectedCountry
          // },
          ShippingAddress: {
            AddressId: 0,
            ShipTo: ((this.userService.shippingAddress?.FirstName || this.userService.customerData?.FirstName || '') + ' ' + (this.userService.shippingAddress?.LastName || this.userService.customerData?.LastName || '')).trim() || '',
            Street1: this.userService.shippingAddress?.Street1 || addressData?.Line1,
            Street2: this.userService.shippingAddress?.Street2 || addressData?.Line2,
            Street3: ' ',
            // StateCode: "UT",
            PostalCode: this.userService.shippingAddress?.PostalCode || this.userService.shippingAddress?.PostalCode || addressData?.Zip,
            City: this.userService.shippingAddress?.City || addressData?.City,
            Region: this.userService.shippingAddress?.Region ? this.userService.shippingAddress.Region : (this.userService.defaultState || this.userService.regionMainState) || addressData?.StateCode,
            CountryCode: this.userService?.selectedCountry ||this.configService.commonData.selectedCountry || selectedCountry,
            FirstName: this.userService.shippingAddress?.FirstName || this.userService.customerData?.FirstName || '',
            LastName: this.userService.shippingAddress?.LastName || this.userService.customerData?.LastName || '',
            Phone: this.userService.shippingAddress?.Phone || this.userService.customerData?.PhoneNumber || '',
            StateName: this.userService.shippingAddress?.StateName || this.userService.shippingAddress?.Region || '',
            FullName: this.userService.shippingAddress?.FullName || (this.userService.shippingAddress?.FirstName + ' ' + this.userService.shippingAddress?.LastName) || ''
          },
          PriceGroup: this.userService.customerTypeID || 2,
          OrderType: 1,
          KitItems: [],
          Items: productdetails,
          PartyId: 0,
          CouponCodes: this.getCouponCodesForOrder(),
          CountryCode: this.userService?.selectedCountry||this.configService.commonData.selectedCountry || DefaultCountry,
          CustomShippingAddress:[{
            Line1: this.userService.shippingAddress?.Street1 || addressData?.Line1,
            Line2: this.userService.shippingAddress?.Street2 || addressData?.Line2,
            Zip:
              this.userService.shippingAddress?.PostalCode ||
              this.userService.shippingAddress?.PostalCode ||
              addressData?.Zip,
            // City: 'TestCity',//this.userService.shippingAddress?.City || addressData?.City,
             City: this.userService.shippingAddress?.City || addressData?.City,
            StateCode: this.userService.shippingAddress?.Region
              ? this.userService.shippingAddress?.Region
              : this.userService.defaultState ||
                this.userService.regionMainState ||
                addressData?.StateCode || "AK",
            CountryCode: this.userService?.selectedCountry || selectedCountry,
          }]
        }
      };

      if (_.isEqual(this.lastRequest, calculateOrderRequest)) {
        resolve(this.calculateOrderResponse);
        // this.router.navigate(['/products/all']);
       
      } else {
        this.lastRequest = cloneDeep(calculateOrderRequest);
        
        if (productdetails.length == 0) {
          if(this.userService.customerTypeID !== 1){
            this.router.navigate(['/products/all']);
          }
          else{
            return;
          }
        }
        // Store shipping address in localStorage before API call
        this.storeShippingAddressInLocalStorage(calculateOrderRequest.calculateOrder.ShippingAddress);
        
        this.apiService.calculateCustomerOrderTotal(calculateOrderRequest).subscribe((result) => {

          // if(result.Data.Item == 0){
          //   this.router.navigate(['/products/all']);
          // }
          this.calculateOrderCall = false;
          try {
            var isLoggedIn = localStorage.getItem('isLoggedIn') || '';
            //if (isLoggedIn && (parseInt(result.Status, 10) === 0)) {
              this.abandonedCart('Standard',result.Data.Items,result.Data.Total)
            //}
          } catch (error) {
            // Handle error silently
          }
          try {
            if (parseInt(result.Status, 10) === 0) {
              this.calculateOrderResponse = result.Data;
              if (this.calculateOrderResponse.CouponResults) {
                this.calculateOrderResponse.CouponResults.forEach((item, index) => {
                  const isInCart = this.userService.couponInfo.Allcoupons.some((code) => {
                    if (code.toLowerCase() == item.Code.toLowerCase()) {
                      return true;
                    }
                    return false;
                  });

                  if (item.IsValid) {
                    if (!isInCart) {
                      this.userService.couponInfo.Allcoupons.push(item.Code);
                    }
                    if (this.userService.couponInfo.promoCode == item.Code) {
                      this.notificationService.success('success', 'coupon_added_success');
                    }

                    this.userService.couponInfo.promoCodeValid = true;

                  } else {
                    this.userService.couponInfo.promoCodeValid = false;
                    this.userService.couponInfo.IsAppliedcode = false;
                    this.userService.couponInfo.promoCode = '';
                    if (isInCart && this.itemsService.selectedOrderItems.length) {
                      this.userService.couponInfo.Allcoupons = this.userService.couponInfo.Allcoupons.filter((code) => {
                        return code.toLowerCase() != item.Code.toLowerCase();
                      });
                      this.userService.couponInfo.RewardsForUse = this.userService.couponInfo.RewardsForUse.filter((e) => {
                        return e.Code.toLowerCase() != item.Code.toLowerCase();
                      });

                    }
                  }

                });
              }
              this.userService.couponInfo.promoCode = '';
              setTimeout(() => {
                this.userService.shippingMethods = result.Data.ShippingMethods;

                if (this.userService.shippingMethods && this.userService.shippingMethods.length) {
                  // Check if the currently selected shipping method is still available
                  const selectedShipmethod = this.userService.shippingMethods.filter((shipMethod) => {
                    return (shipMethod.ShipMethodId === this.userService.selectedShippingMethod);
                  });
                  
                  if (selectedShipmethod.length > 0) {
                    // Keep the currently selected shipping method if it's still available
                    this.userService.selectedShippingMethod = this.userService.selectedShippingMethod ||
                      selectedShipmethod[0].ShipMethodId;
                  } else {
                    // Set the first shipping method as default if current selection is not available
                    this.userService.selectedShippingMethod = this.userService.shippingMethods[0].ShipMethodId;
                  }
                }
            }, 100);

              // pack total
              if (this.itemsService.selectedPacks.length) {
                this.packTotal = 0;
                this.packBusinessVolume = 0;
                const selectedPacks = cloneDeep(this.itemsService.selectedPacks);
                this.itemsService.selectedPacks = [];
                selectedPacks.forEach((item) => {
                  // Try to find matching item in API response
                  const matchingItem = this.calculateOrderResponse.Items.find(item1 => item.ItemID == item1.ItemId);
                  
                  if (matchingItem) {
                    item.Price = matchingItem.Price || matchingItem.PriceEach || item.Price;
                    item.RV = matchingItem.RV || item.RV || 0; // Preserve original RV if API doesn't provide it
                    this.packTotal = this.packTotal + (item.Quantity * item.Price);
                    this.packBusinessVolume = this.packBusinessVolume + (item.Quantity * (item.RV || 0));
                    this.itemsService.selectedPacks.push(item);
                  } else {
                    // If no matching item found in API response, use original values
                    this.packTotal = this.packTotal + (item.Quantity * item.Price);
                    this.packBusinessVolume = this.packBusinessVolume + (item.Quantity * (item.RV || 0));
                    this.itemsService.selectedPacks.push(item);
                  }
                });
              }
              // order total
              if (this.itemsService.selectedOrderItems.length) {
                this.orderTotal = 0;
                this.orderRewardTotal = 0;
                this.orderBusinessVolume = 0;
                const selectedOrderItems = cloneDeep(this.itemsService.selectedOrderItems);
                this.itemsService.selectedOrderItems = [];
                selectedOrderItems.forEach((item) => {
                  this.calculateOrderResponse.Items.forEach((item1) => {
                    if (item1.CurrencyCode == 'RWD') {
                      item1.UsePoints = true;
                    }

                    if (item.ItemID == item1.ItemId && !!item.UsePoints == !!item1.UsePoints) {
                      item.Price = item1.Price || item1.PriceEach || item.Price;
                      // Preserve RV field from original product data since API response doesn't include RV
                      // The RV field should already be set from the original product when it was added to cart
                      if (item.RV === undefined || item.RV === null) {
                        item.RV = 0;
                      }
                      
                      
                      if (item1.CurrencyCode == 'RWD') {
                        this.orderRewardTotal = this.orderRewardTotal + (item1.Quantity * (item1.Price || item1.PriceEach || 0));
                      }
                      else {
                        this.orderTotal = this.orderTotal + (item1.Quantity * (item1.Price || item1.PriceEach || 0));
                      }
                      item1.BusinessVolumeTotal = this.orderBusinessVolume + (item1.Quantity * (item.RV || 0));
                      this.orderBusinessVolume = this.orderBusinessVolume + (item1.Quantity * (item.RV || 0));
                      this.itemsService.selectedOrderItems.push(item);
                    }
                  });
                });
              }
              if (showNotification) {
                this.notificationService.success('success', this.translate.instant('item_added_your_order_shopping_cart'));
              }
              resolve(result);
            } else {
              const getMessage = result.Message.toLowerCase().includes('Api returned 404 Not Found'.toLowerCase());
              let getItemName;
              if (getMessage && getMessage !== null) {
                const getNumber = result.Message;
                const getItemCode = getNumber.match(new RegExp('Item with Id' + '\\s(\\w+)'))[1]; // getNumber.replace(/\D/g, '');
                let getItemDetails = this.itemsService.selectedOrderItems;
                if (this.itemsService.selectedPacks.length > 0) {
                  getItemDetails = getItemDetails.concat(this.itemsService.selectedPacks);
                }
                getItemDetails.forEach((item, index) => {
                  if (item.ItemID == getItemCode) {
                    getItemName = item.ProductName;
                  }
                });

                this.translate.get('error_item_not_found').subscribe( (text: string) => {
                  this.notificationService.error('error_', this.translate.instant('error_item_not_found') + ' ' + getItemName);
                });

                            } else {
                // Check if this is a BounceBack coupon error for special handling
                const couponCodes = this.getCouponCodesForOrder();
                const hasBounceBackCoupon = couponCodes.some(code => 
                  this.bounceBackService.isBounceBackCoupon(code)
                );
                
                if (hasBounceBackCoupon) {
                  // For BounceBack errors: resolve with error result so component can handle API errors properly
                  resolve(result);
                } else {
                  // For non-BounceBack errors: show notification and reject (original behavior)
                  this.notificationService.error('error_', result.Message);
                  reject(result);
                }
              }
            }
          } catch (ex) {

            this.notificationService.error('error_', 'error_occured_try_again');
            reject(ex);
          }
        }, (error) =>  {
          // this.calculateOrderCall = false;
          reject(error);
        });
      }

    });
    return promise;
  }
  /**
   * Store shipping address in localStorage under userService.shippingAddress
   * @param shippingAddress - The shipping address object to store
   */
  private storeShippingAddressInLocalStorage(shippingAddress: any): void {
    try {
      // Get existing userService from localStorage
      let userService = JSON.parse(localStorage.getItem('userService') || '{}');
      
      // Update the shippingAddress with the new one
      userService.shippingAddress = shippingAddress;
      
      // Save back to localStorage
      localStorage.setItem('userService', JSON.stringify(userService));
      
      // Also update the current userServiceModal instance
      if (this.userService) {
        this.userService.shippingAddress = shippingAddress;
      }
    } catch (error) {
      console.warn('Error storing shipping address in localStorage:', error);
    }
  }

  /***calculate Auto Order***/

  public calculateAutoOrder(showNotification?: boolean, editAutoship?: boolean): any {
    const promise = new Promise((resolve, reject) => {
      this.PreventTaxJarCalculation = true;
      let orderSubtotal = 0;
      const productdetails = [];
      this.itemsService.selectedAutoOrderItems.forEach((item, index) => {
        // Use Price field since cart service sets it to the correct autoship price
        const itemTotal = (item.Price || 0) * (item.Quantity || 1); // Ensure price and quantity exist
        orderSubtotal += itemTotal;
        productdetails.push({
          ItemId: item.ItemID,
          Quantity: item.Quantity,
          IsKitItem: false
        });
      });
      // this.CustomerTypeChanged();
      const selectedCountry = this.configService.commonData.selectedCountry || DefaultCountry;
      const addressData = this.configService.commonData?.CountryCode?.[selectedCountry];
      
      // Set the first shipping method ID by default for autoship
      let shipMethodId = this.userService?.selectedShippingMethod;
      
      // If no shipping method is selected, use the shipping method service to get the default
      if (!shipMethodId) {
        shipMethodId = this.shippingMethodService.getShippingMethodId(orderSubtotal, this.userService.customerTypeID, true);
      }
      
      // If still no shipping method, use the default from constants
      if (!shipMethodId) {
        shipMethodId = DefaultShipMethodID;
      }
      // Enrollment-flow override (T-0129): if we're in /join, /complete, /application
      // or the cart has an enrollment pack, force ENROLLMENTSTORE here too. Otherwise
      // fall through to the prior autoship/store-from-sessionStorage logic.
      let storeId: string;
      if (this.isEnrollmentContext()) {
        storeId = this.storeConstantsService.getCurrentStoreConstants().ENROLLMENTSTORE;
      } else {
        storeId = sessionStorage.getItem('selectedStoreId');
        // If no store ID in sessionStorage, check if we have autoship items and use autoship store
        if (!storeId && this.itemsService.selectedAutoOrderItems.length > 0) {
          storeId = '5'; // Autoship store ID
        }
        // Fallback to autoship store ID if still no store ID
        if (!storeId) {
          storeId = this.autoshipStoreId || AUTOSHIPSTOREID;
        }
      }
      

      
      const calculateOrderRequest = {
        customerType: this.userService.customerTypeID || this.userService.customerData?.CustomerType || 2,
        customerId: this.userService.customerData.CustomerId,
        OrderId:"",
        calculateOrder: {
          // WarehouseId: 0,
          ShipMethodId: shipMethodId,
          StoreId: storeId,
          CurrencyCode: this.companyService.selectedCurrency.CurrencyCode || "USD",
          ShippingAddress: {
            AddressId: 0,
            FirstName: String(this.userService.shippingAddress?.FirstName || this.userService.customerData?.FirstName || '').trim(),
            LastName: String(this.userService.shippingAddress?.LastName || this.userService.customerData?.LastName || '').trim(),
            ShipTo: ((this.userService.shippingAddress?.FirstName || this.userService.customerData?.FirstName || '') + ' ' + (this.userService.shippingAddress?.LastName || this.userService.customerData?.LastName || '')).trim() || '',
            Street1: this.userService.shippingAddress?.Street1 || addressData?.Line1,
            Street2: this.userService.shippingAddress?.Street2 || addressData?.Line2,
            Street3: '',
            PostalCode: this.userService.shippingAddress?.PostalCode || this.userService.shippingAddress?.PostalCode || addressData?.Zip,
            City: this.userService.shippingAddress?.City || addressData?.City,
            Region: this.userService.shippingAddress?.Region
            ? this.userService.shippingAddress.Region : (this.userService.defaultState || this.userService.regionMainState) || addressData?.StateCode,
            // || this.itemsService.getState() || this.userService.shippingAddress.MainState);,
            CountryCode: this.userService?.selectedCountry || selectedCountry
          },
          PriceGroup: this.userService.customerTypeID || 2,
          OrderType: 2,
          KitItems: [],
          Items: productdetails,
          PartyId: 0,
          CouponCodes: this.getCouponCodesForOrder(),
          CountryCode: this.userService?.selectedCountry || selectedCountry || DefaultCountry,
          CustomShippingAddress:[{
            Line1: this.userService.shippingAddress?.Street1 || addressData?.Line1,
            Line2: this.userService.shippingAddress?.Street2 || addressData?.Line2,
            Zip:
              this.userService.shippingAddress?.PostalCode ||
              this.userService.shippingAddress?.PostalCode ||
              addressData?.Zip,
            City: this.userService.shippingAddress?.City || addressData?.City,
            StateCode: this.userService.shippingAddress?.Region
              ? this.userService.shippingAddress?.Region
              : this.userService.defaultState ||
                this.userService.regionMainState ||
                addressData?.StateCode ,
            CountryCode: this.userService?.selectedCountry || selectedCountry,
          }]
        }
      };
      if (!editAutoship && _.isEqual(this.lastAutoOrderRequest, calculateOrderRequest)) {
        resolve(this.calculateAutoOrderResponse);

      } else {
        
        if (productdetails.length == 0) {
          return;
        }
        this.lastAutoOrderRequest = cloneDeep(calculateOrderRequest);
        this.apiService.calculateCustomerOrderTotal(calculateOrderRequest).subscribe((result) =>  {
          try {
            var isLoggedIn = localStorage.getItem('isLoggedIn') || '';
            // if (isLoggedIn && (parseInt(result.Status, 10) === 0)) {
              this.abandonedCart('Autoship',result.Data.Items,result.Data.Total)
            // }
          } catch (error) {
          }
          try {

            if (parseInt(result.Status, 10) === 0) {
              this.calculateAutoOrderResponse = result.Data;
              if (showNotification) {
                this.notificationService.success('success', this.translate.instant('item_added_in_your_autoship'));
              }
              this.autoorderBusinessVolume = 0;
              const selectedAutoOrderItems = cloneDeep(this.itemsService.selectedAutoOrderItems);
              this.itemsService.selectedAutoOrderItems = [];
              
              // Recalculate subtotal using corrected cart item prices
              let recalculatedSubtotal = 0;
              
              selectedAutoOrderItems.forEach((autoitem, index) => {
                this.calculateAutoOrderResponse.Items.forEach((item1) => {
                  if (autoitem.ItemID == item1.ItemId) {
                    // Store the original autoship price before any API overrides
                    const originalPrice = autoitem.Price;
                    
                    // For autoship items, NEVER override the price set by cart service
                    // The API might return one-time prices even for autoship store requests
                    if (originalPrice && originalPrice > 0) {
                      // Explicitly keep the original price - don't let API override it
                      autoitem.Price = originalPrice;
                    } else {
                      autoitem.Price = item1.Price || item1.PriceEach;
                    }
                    
                    // Add to recalculated subtotal using the corrected price
                    recalculatedSubtotal += (autoitem.Price || 0) * (autoitem.Quantity || 1);
                    
                    autoitem.CV = item1.Cv;
                    autoitem.QV = item1.Qv;
                    // Preserve RV field from original product data since API response doesn't include RV
                    // The RV field should already be set from the original product when it was added to cart
                    if (autoitem.RV === undefined || autoitem.RV === null) {
                      autoitem.RV = 0;
                    }
                    
                    autoitem.BusinessVolumeTotal = this.autoorderBusinessVolume + (item1.Quantity * (autoitem.RV || 0));
                    this.autoorderBusinessVolume = this.autoorderBusinessVolume + (item1.Quantity * (autoitem.RV || 0));
                  }
                });
              });
              
              // Store original API values before overwriting them
              const originalApiSubtotal = this.calculateAutoOrderResponse.SubTotal || 0;
              const originalApiTaxTotal = this.calculateAutoOrderResponse.TaxTotal || 0;
              
              // Override the API response subtotal with our recalculated subtotal
              this.calculateAutoOrderResponse.SubTotal = recalculatedSubtotal;
              
              // FIX: Recalculate tax using the API's tax rate but applied to the correct autoship price
              // The API calculated tax on the one-time price, but we need to apply the same tax rate to the autoship price
              // Only calculate tax if the API actually returned tax (respects tax-exempt states)
              let correctedTaxTotal = 0;
              if (originalApiSubtotal > 0 && originalApiTaxTotal > 0) {
                const apiTaxRate = originalApiTaxTotal / originalApiSubtotal;
                correctedTaxTotal = recalculatedSubtotal * apiTaxRate;
              }
              // If API returns 0 tax (tax-exempt state), leave tax as 0 - don't force tax calculation
              

              
              // Recalculate the total based on the corrected subtotal and tax
              const shippingTotal = this.calculateAutoOrderResponse.ShippingTotal || 0;
              const discountTotal = this.calculateAutoOrderResponse.DiscountTotal || 0;
              this.calculateAutoOrderResponse.TaxTotal = correctedTaxTotal;
              this.calculateAutoOrderResponse.Total = recalculatedSubtotal + shippingTotal + correctedTaxTotal - discountTotal;
              
              // this.userService.shippingMethods = result.Data.shippingMethods;
              if (this.userService.shippingMethods && this.userService.shippingMethods.length) {
                // Check if the currently selected shipping method is still available
                const selectedShipmethod = this.userService.shippingMethods.filter((shipMethod) =>  {
                  return (shipMethod.ShipMethodID === this.userService.selectedShippingMethod);
                });
                
                if (selectedShipmethod.length > 0) {
                  // Keep the currently selected shipping method if it's still available
                  this.userService.selectedShippingMethod = this.userService.selectedShippingMethod || selectedShipmethod[0].ShipMethodID;
                }
                else {
                  // Set the first shipping method as default if current selection is not available
                  this.userService.selectedShippingMethod = this.userService.shippingMethods[0].ShipMethodID;
                }
              }
              this.itemsService.selectedAutoOrderItems = selectedAutoOrderItems;
              resolve(result);
            } else {
              const getMessage = result.Message.toLowerCase().includes('Api returned 404 Not Found'.toLowerCase());
              let getItemName;
              if (getMessage && getMessage !== null) {
                const getNumber = result.Message;
                const getItemCode = getNumber.match(new RegExp('Item with Id' + '\\s(\\w+)'))[1]; // getNumber.replace(/\D/g, '');
                const getItemDetails = this.itemsService.selectedAutoOrderItems;
                getItemDetails.forEach((item, index) => {
                  if (item.ItemID == getItemCode) {
                    getItemName = item.ProductName;
                  }
                });

                this.translate.get('error_item_not_found').subscribe( (text: string) => {
                  this.notificationService.error('error_', this.translate.instant('error_item_not_found') + ' ' + getItemName);
                });
              } else {
                this.notificationService.error('error_', result.Message);
              }
              reject(result);
            }
          } catch (ex) {

            this.notificationService.error('error_', 'error_occured_try_again');
            reject(ex);
          }
        }, (error) =>  {
          // A ship method the calc service rejects (stale selection, removed
          // method) must not wedge the subscription UI: retry once with the
          // default. The retry sends DefaultShipMethodID, so a second failure
          // falls through to reject — no loop.
          if (String(shipMethodId) !== DefaultShipMethodID) {
            this.userService.selectedShippingMethod = DefaultShipMethodID;
            this.calculateAutoOrder(showNotification, editAutoship).then(resolve, reject);
          } else {
            reject(error);
          }
        });
      }
    });
    return promise;
  }

  public abandonedCart(type,items,total){
    var data1:any ;
    var cartItems:any = [];
    if (items.length > 0) {
      items.forEach(element => {
        cartItems.push({
          "itemId": element.ItemId,
          "productName": element.ProductName,
          "sku": element.Sku,
          "quantity": element.Quantity,
          "qv": element.Qv,
          "cv": element.Cv,
          "rv": element.RV || 0,
          "bonus": element.Bonus,
          "price": element.price,
          "languageCode": element.LanguageCode,
          "currencyCode": element.CurrencyCode
        });
      });
    }
    try {
      if(this.user.userServiceModal && Object.keys(this.user.userServiceModal.customerData).length>0){
        data1 = [{
          "type": type,
          "cartItem": cartItems,
          "price": total,
          "enrollerInfo": {
            "customerId": this.userService.enrollerInfo.CustomerId,
            "backOfficeId": this.userService.enrollerInfo.BackOfficeId,
            "firstName": this.userService.enrollerInfo.FirstName,
            "lastName": this.userService.enrollerInfo.LastName,
            "webAlias": this.userService.enrollerInfo.WebAlias,
            "phoneNumber": this.userService.enrollerInfo.PrimaryPhone,
            "emailAddress": this.userService.enrollerInfo.EmailAddress,
            "country": this.userService.enrollerInfo.Country,
            "region": this.userService.enrollerInfo.Region
          },
          "customerInfo": {
            "customerId": this.user.userServiceModal.customerData.CustomerId ? this.user.userServiceModal.customerData.CustomerId : '',
            "backOfficeId": this.user.userServiceModal.customerData.BackOfficeId ? this.user.userServiceModal.customerData.BackOfficeId: '',
            "firstName": this.user.userServiceModal.customerData.FirstName ? this.user.userServiceModal.customerData.FirstName : '',
            "lastName": this.user.userServiceModal.customerData.LastName ? this.user.userServiceModal.customerData.LastName : '',
            "webAlias": this.user.userServiceModal.customerData.WebAlias ? this.user.userServiceModal.customerData.WebAlias : '',
            "phoneNumber": this.user.userServiceModal.customerData.PrimaryPhone ? this.user.userServiceModal.customerData.PrimaryPhone : '',
            "emailAddress": this.user.userServiceModal.customerData.EmailAddress ? this.user.userServiceModal.customerData.EmailAddress : '',
            "country": this.user.userServiceModal.customerData.PrimaryAddress.CountryCode ? this.user.userServiceModal.customerData.PrimaryAddress.CountryCode : '',
            "region": this.user.userServiceModal.customerData.PrimaryAddress.Region ? this.user.userServiceModal.customerData.PrimaryAddress.Region : this.user.userServiceModal.customerData.PrimaryAddress.Region,
          }
        }]
      }
      else{
         data1 = [{
          "type": type,
          "cartItem": cartItems,
          "price": total,
          "enrollerInfo": {
            "customerId": this.userService.enrollerInfo.CustomerId,
            "backOfficeId": this.userService.enrollerInfo.BackOfficeId,
            "firstName": this.userService.enrollerInfo.FirstName,
            "lastName": this.userService.enrollerInfo.LastName,
            "webAlias": this.userService.enrollerInfo.WebAlias,
            "phoneNumber": this.userService.enrollerInfo.PrimaryPhone,
            "emailAddress": this.userService.enrollerInfo.EmailAddress,
            "country": this.userService.enrollerInfo.Country,
            "region": this.userService.enrollerInfo.Region
          },
          "customerInfo": {
          }
        }]
      }
      var tempData = JSON.stringify(data1);
      //window['ZTM'].setStats('commonsense','AbandonedCart',tempData);
    } catch (error) {      
    }
  }
  /** *Reset last requests
   * @method  resetLastRequests
   * Reset last requests in case of continue shoppings.
   */
  public resetLastRequests(): any {
    this.lastRequest = {};
    this.lastAutoOrderRequest = {};
  }
  getstoreId() {
    this.apiService.getStores().subscribe((result) => {
      // Update the global store constants based on API response
      if (result && result.Data && Array.isArray(result.Data)) {
        this.storeConstantsService.updateStoreConstants(result.Data);
      }
      
      // Update local service properties with the updated constants
      // Get current store constants after update
      const currentConstants = this.storeConstantsService.getCurrentStoreConstants();
      this.autoshipStoreId = currentConstants.MEMBERSTORE;
      this.retailStoreId = currentConstants.MAINSTORE;
      this.enrollStoreId = currentConstants.ENROLLMENTSTORE;
    })
  }
  isLoggedIn(): boolean{
    let isLoggedIn = false;
    this.apiService.loginStatus.subscribe(val => {
      isLoggedIn =  val;
    });
    return isLoggedIn;
  }
  CustomerTypeChanged(){
    if(this.itemsService.selectedPacks.length == 0){
      const freeEnrollmentItem = this.itemsService.selectedOrderItems.includes((item) => item.ItemID == FreeEnrollmentItemID);
      const freeEnrollmentZeroPriceItemID = this.itemsService.selectedOrderItems.includes((item) => item.ItemID == FreeEnrollmentZeroPriceItemID);
      if(!freeEnrollmentItem && !freeEnrollmentZeroPriceItemID && !this.router.url.includes('join') && !this.isLoggedIn()){
        if(this.itemsService.selectedAutoOrderItems.length > 0){
          this.userService.customerTypeID = this.userService.customerData?.CustomerType || 2;
        }
        else{
          this.userService.customerTypeID = this.userService.customerData?.CustomerType || 2;
        }
      }
      else{
        this.userService.customerTypeID = 1;
      }
    }else{
      this.userService.customerTypeID = 1;
    }
  }

  /**
   * Get all coupon codes for order calculation including BounceBack coupons
   */
  private getCouponCodesForOrder(): string[] {
    if (!this.configService.localSettings.Global.OrderAllowCoupons) {
      return [];
    }

    const couponCodes = [];

    // Add existing coupons from user service (excluding BounceBack coupons to prevent duplicates)
    if (this.userService.couponInfo.Allcoupons && this.userService.couponInfo.Allcoupons.length > 0) {
      const nonBounceBackCoupons = this.userService.couponInfo.Allcoupons.filter(
        code => !this.bounceBackService.isBounceBackCoupon(code)
      );
      couponCodes.push(...nonBounceBackCoupons);
    }

    // Add BounceBack coupon if available and valid in session storage
    try {
      const bounceBackCoupon = sessionStorage.getItem('bounceBackAppliedCoupon');
      if (bounceBackCoupon) {
        const couponData = JSON.parse(bounceBackCoupon);
        if (couponData && couponData.isValid && couponData.code && this.bounceBackService.isBounceBackCoupon(couponData.code)) {
          couponCodes.push(couponData.code);
        }
      }
    } catch (error) {
      console.warn('Error parsing BounceBack coupon from session storage:', error);
      // Clear invalid session storage data
      try {
        sessionStorage.removeItem('bounceBackAppliedCoupon');
        sessionStorage.removeItem('bounceBackDiscountAmount');
      } catch (clearError) {
        console.warn('Error clearing invalid BounceBack session data:', clearError);
      }
    }

    // Remove duplicates and return
    return [...new Set(couponCodes)];
  }
}
